import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import Page from 'components/common/Page';
import { ProductName } from 'domain/product/enums/ProductName';
import PageHeading from 'components/common/Product/PageHeading';
import menuConfig from './menuConfig';
import TopMenu from 'components/common/Menu/top-menu';

const FlexInsightOutlet: FunctionComponent = () => (
	<Page>
		<PageHeading product={ProductName.FlexInsight} />
		<TopMenu menuConfig={menuConfig} />
		<Outlet />
	</Page>
);

export default FlexInsightOutlet;
